import React from 'react';
import styled from 'styled-components';

const p = styled.div`
    color: ${p => p.theme.colors.primaryText};
    padding-bottom: 1rem;
    padding-top: 1rem;
`;

export default p;

